export const membershipRouteNames = {
  default: 'membership-v2',
  clientPortal: {
    dashboard: 'clientportal-dashboard-memberships',
    domainSetup: 'clientportal-domain-setup-memberships',
    branding: 'branding-memberships',
    appPermission: 'app-permission-memberships',
    brandedApp: 'branded-app-memberships',
    settings: 'clientportal-settings-memberships',
    emailSettings:'email-settings-memberships',
    languageSettings:'language-settings-memberships',
    chatWidget: 'chat-widget-settings-memberships',
  },
  courses: {
    coursesThemesOverview: 'courses-themes-overview',
    coursesThemeCustomizer: 'courses-theme-customizer',
    coursesTemplateCustomizer: 'courses-template-customizer',
    dashboard: 'membership-dashboard-v2',
    productBlueprint: 'product_blueprints-v2',
    productCertificate: 'product-certificates',
    courseImporter: 'course-importer',
    membershipManageComments: 'membership-manage-comments-v2',
    membershipProductComments: 'membership-product-comments',
    categoriesEdit: 'categories-edit-v2',
    products: {
      membershipProducts: 'membership-products-v2',
      membershipLibrary: 'membership-library-order-v2',
      membershipProductOverview: 'membership-product-overview-v2',
      membershipProductEdit: 'membership-product-edit-v2',
      membershipProductOffers: 'membership-product-offers',
    },
    offerEdit: 'courses-offer-edit-v2',
    membershipOffers: {
      default: 'membership-offers-v2',
      coursesOfferCustomization: 'courses-offer-customization-v2',
      upSellHome: 'upsell-home-v2',
      detail: 'membership-offer-detail-v2',
    },
    assignmentEvaluation: 'assignment-evaluation',
    membershipAnalytics: {
      default: 'membership-analytics-v2',
      productProgress: 'membership-product-progress-v2',
      memberProgress: 'member-progress-v2',
      assessment: 'membership-analytics-assessments-v2',
      assessmentSubmission: 'membership-analytics-assessment-submission-v2',
    },
    offersV2: 'offers-v2',
    productGroups: 'product-groups',
    productOffersV2: 'product-offers-v2',
    offersOverview: 'offers-overview-v2',
    membershipNetRevenueAnalytics: 'membership-netrevenue-analytics',
    membershipMembersAnalytics: 'membership-members-analytics',
    membershipMembersProgress: 'membership-members-progress',
    membershipPostEdit: 'membership-post-edit',
    membershipSettings: {
      default: 'membership-settings-v2',
      siteDetails: 'membership-site-details-v2',
      customDomain: 'membership-custom-domain-v2',
      emailSettings: 'membership-email-settings-v2',
      appSettings: 'membership-app-settings-v2',
    },
    membershipCategories: {
      default: 'membership-categories-v2',
      edit: 'membership-category-edit',
    },
    postAssignment: 'post-assignment-v2',
    postQuiz: 'post-quiz-v2',
    membershipPosts: {
      default: 'membership-posts-v2',
      postEdit: 'membership-post-edit',
    },
    membershipTheme: {
      default: 'membership-themes-v2',
      editTheme: 'membership-edit-themes-v2',
    },
    membershipNewTheme: {
      default: 'membership-themes-new-v2',
      editTheme: 'membership-edit-themes-new-v2',
      editV2Theme: 'membership-edit-v2-themes',
      productAllTheme: 'membership-product-all-themes',
    },
  },
  certificates: {
    default: 'certificates',
    create: 'create-certificates',
    edit: 'edit-certificates',
    editBadges: 'edit-badges',
  },
  communities: {
    default: 'communities',
    groups: 'community-groups',
    createGroup: 'create-group',
  },
  gokollab: {
    default: 'gokollab',
    activation: 'activation',
  },
  communitiesBrandedApp: 'communities-branded-app',
  communitiesDomainSetup: 'communities-domain-setup',
}
